"use client"

import { motion, useScroll, useTransform } from "motion/react"

export default function TopHeader({ children }: { children: React.ReactNode }) {
  const { scrollY } = useScroll()

  const backgroundColorTransform = useTransform(
    scrollY,
    [0, 4 * 75],
    ["rgba(255, 255, 255, 1)", "rgba(255, 255, 255, 1)"]
  )

  const backdropBlurTransform = useTransform(
    scrollY,
    [0, 4 * 75],
    ["blur(0px)", "blur(16px)"]
  )

  return (
    <motion.header
      className="sticky top-0 z-50 flex-none border-b border-[#F2F3F5]"
      style={{
        background: backgroundColorTransform,
        backdropFilter: backdropBlurTransform,
      }}
    >
      {children}
    </motion.header>
  )
}
